import Route from '@ember/routing/route';
import { later, cancel } from '@ember/runloop';
import { inject as service } from '@ember/service';

export default class ClassGroupResultsEnduroRoute extends Route 
{
	@service ajax
	
	resultsTimer = null
	
	resultsRefreshInterval = 10000
	
	async model(params) 
	{
		const results = await this.fetchResults();	
		return results;
	}
	
	setupController(controller, model) 
	{
		controller.set('results', model);
	    controller.set('event', this.modelFor('event'));
		controller.set('classGroup',this.modelFor('event/class-group'))
	}
	
	async fetchResults()
	{
		let results = await this.ajax.request("enduroResults");
		results = await results.map(function(result)
		{
			return result.data.attributes;
		});
		return results;
	}
	
	async fetchResultsLoop()
	{
		cancel(this.resultsTimer);
		this.resultsTimer = later(this,async function()
		{
			const results = await this.fetchResults();
			this.controller.set('results', results);
			
			this.fetchResultsLoop();
		},this.resultsRefreshInterval);
	}
	
	activate(transition)
	{
		this.fetchResultsLoop();
	}
	
	deactivate(transition)
	{
		cancel(this.resultsTimer);
	}
}